export { default as useScript } from './use-script';
